module.exports = __webpack_public_path__ + "img/return.aab48147.svg";